const CONSENT_KEY = 'gympera_tracking_consent';

interface TrackingConsent {
  analytics: boolean;
  location: boolean;
}

const DEFAULT_CONSENT: TrackingConsent = { analytics: true, location: false };

export function getConsent(): TrackingConsent {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return DEFAULT_CONSENT;
    const parsed = JSON.parse(raw);
    return {
      analytics: typeof parsed.analytics === 'boolean' ? parsed.analytics : DEFAULT_CONSENT.analytics,
      location: typeof parsed.location === 'boolean' ? parsed.location : DEFAULT_CONSENT.location,
    };
  } catch {
    return DEFAULT_CONSENT;
  }
}

export function setConsent(consent: TrackingConsent): void {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
}
